import { UserManagerSettings, WebStorageStateStore } from 'oidc-client'
import { environment } from '../../environments/environment'

export const AuthConfiguration: UserManagerSettings = {
    client_id: environment.clientId,
    redirect_uri: `${environment.baseUrl}/authentication/callback`,
    response_type: 'code',
    post_logout_redirect_uri: environment.baseUrl,
    scope: 'openid email profile swm:identifier',
    authority: environment.idp,
    silent_redirect_uri: `${environment.baseUrl}/authentication/silent_callback`,
    automaticSilentRenew: true,
    response_mode: 'query',
    userStore: new WebStorageStateStore({ store: localStorage }),
    staleStateAge: 43200, // 12 hours
    extraQueryParams: environment.audience
        ? {
              audience: environment.audience,
          }
        : {},
}
